import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-medium",
  templateUrl: "./med-icon-medium.component.html",
})
export class MedIconMediumComponent extends SvgMixinComponent {}
